import React, { useContext, useState } from "react";
import { MyContext } from "../MyProvider";
import { USER_LOCAL_ID } from "../../constants";
import { scAxiosAdmin } from "../..";
import { toast } from "react-toastify";

const BookTestPopUp = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    phoneNuber: "",
  });
  const { cart, totalAmount, removeFromCart } = useContext(MyContext);

  const handleSubmit = (event, props) => {
    event.preventDefault();

    const postData = {
      type: "investigation_request",
      additional: cart,
      user_id: localStorage.getItem(USER_LOCAL_ID),
      currency: "BDT",
      amount: totalAmount,
      customer_data: { phone_number: formData.phoneNuber },
      payment_type: "booking",
      status: 1,
    };
    setLoading(true);
    try {
      const response = scAxiosAdmin
        .post("/ledger", postData, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": `application/json`,
          },
        })
        .then((response) => {
          console.log("some data", response);
          if (response.status === 201) {
            toast.success("Your Test Request Booked Successfully!");
            removeFromCart();
            setLoading(false);
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  const inputStyles = {
    borderRadius: "10px",
    background: "#fff",
    borderRight: "solid 1px #fff",
    border: "solid 2px #6e6e6ed0",
    padding: "15px 15px",
    fontSize: "16px",
    color: "#000",
    width: "100%",
  };
  return (
    <div
      class="offcanvas offcanvas-end"
      tabindex="-1"
      id="bookTestOffcanvasRight"
      aria-labelledby="bookTestOffcanvasRightLabel"
      style={{ minWidth: "30%", zIndex: 99999999999999999 }}
    >
      <div
        class="offcanvas-header"
        style={{ paddingRight: "2rem", paddingLeft: "2rem" }}
      >
        <div className="" style={{ paddingTop: "5rem" }}>
          <h4 style={{ color: "#187979" }}>Confirm Your Booking!</h4>
        </div>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <div className="left-offcanvas">
          <h4 style={{ color: "#187979" }}>Enter your phone Number here.</h4>
          <form
            onSubmit={handleSubmit}
            id="registerform"
            className="needs-validation"
            noValidate
          >
            <div className="row">
              <label>Phone Number</label>
              <div className="input-group mt-2">
                <input
                  style={inputStyles}
                  type="number"
                  className="custom-form-control"
                  placeholder="Enter your phone number"
                  name="phoneNumber"
                  id="phoneNumber"
                  value={formData.phoneNuber}
                  onChange={(e) =>
                    setFormData({ ...formData, phoneNuber: e.target.value })
                  }
                  required
                  autoComplete="off"
                  // style={input_field_css}
                />
              </div>

              <span /* style={alertStyle} */>
                {/* {this.state.errors.fullname} */}
              </span>
            </div>
            <div className="row" style={{ padding: "15px" }}>
              <button
                style={{
                  padding: "5px",
                  borderRadius: "5px",
                  backgroundColor: !formData.phoneNuber
                    ? "gray"
                    : "rgb(24, 121, 121)",
                }}
                disabled={!formData.phoneNuber ? true : false}
                type="submit"
                className="text-white d-flex justify-content-center align-items-center gap-4"
                // className={`${
                //   !formData.phoneNuber ? "text-black" : "text-white"
                // }`}
              >
                {loading && (
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                )}
                <span>Submit</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BookTestPopUp;



// WEBPACK FOOTER //
// ./src/component/frontend/BooTestPopUp.js